var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCooking = function SvgCooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.811 26.0512L9.43574 34.4264C8.45942 35.4027 6.87651 35.4027 5.9002 34.4264C4.92389 33.4501 4.92389 31.8672 5.9002 30.8908L14.2754 22.5156M29.0062 5.17188L21.193 12.9849C19.8914 14.2867 19.8914 16.3972 21.193 17.699L22.3716 18.8774C22.9967 19.5026 23.8446 19.8538 24.7286 19.8538C25.6127 19.8538 26.4605 19.5026 27.0856 18.8774L34.8987 11.0644M27.209 12.8579L31.9458 8.12109M25.3153 21.8168L26.7331 23.2076L21.4298 28.5109C21.2735 28.6671 21.0616 28.7549 20.8406 28.7549C20.6196 28.7549 20.4076 28.6671 20.2513 28.5109L14.1745 22.434C8.76298 17.0225 7.00823 10.0035 10.2551 6.75662H10.2822L10.2578 6.75391L26.7223 23.2184M30.1621 15.791L24.2695 9.89844M23.1953 26.7344L26.7308 23.1988L34.4331 30.901C35.4094 31.8774 35.4094 33.4603 34.4331 34.4366C33.4567 35.4129 31.8738 35.4129 30.8975 34.4366L23.1953 26.7344Z",
    stroke: "#E8EBEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCooking;